export default {
  SINGLE: 'single',
  PAIR: 'pair',
  ROW: 'row',
  APARTMENT: 'apartment'
};
